import script from "./CheckInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckInput.vue?vue&type=script&setup=true&lang=js"

import "./CheckInput.vue?vue&type=style&index=0&id=3a94b542&lang=less"

const __exports__ = script;

export default __exports__